import instance from './AxiosService';

const PlayService = {
  getAllAdmin: async () => {
    return await instance.get('/play/admin/all');
  },
  uploadGame: async (formData) => {
    return await instance.post('/play/admin/upload-game', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  toggleGame: async (gameId) => {
    return await instance.patch(`/play/admin/${gameId}/toggle`);
  },
  resetRecord: async (gameId, benchmarkScore) => {
    return await instance.post(`/play/admin/${gameId}/reset-record`, { benchmarkScore });
  },
};

export default PlayService;

